import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SharedStoreEffects, customerReducer, reducer } from './index';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('navigations', reducer),
    StoreModule.forFeature('customer', customerReducer),
    EffectsModule.forFeature([SharedStoreEffects]),
  ],
  providers: [],
})
export class SharedStoreModule {}
